import Personvern from "./Personvern";

export default Personvern;